import React, { useEffect, useRef, useState } from "react";
import { Animated } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";

interface BackgroundProps {
    backgroundColour: string;
    toValue: number;
    duration: number;
    onComplete?: () => void;
}

export const FadeInFromColour: React.FC<BackgroundProps> = ({
    backgroundColour: backgroundColor,
    toValue,
    duration,
    onComplete,
}) => {
    const opacity = useRef(new Animated.Value(1)).current;
    const styles = useDynamicStyles(calculateStyles);
    const [display, setDisplay] = useState<string>("block");

    useEffect(() => {
        Animated.timing(opacity, {
            toValue,
            useNativeDriver: true,
            duration,
        }).start(() => {
            setDisplay("none");
            if (onComplete) {
                onComplete();
            }
        });
    }, [opacity, toValue, duration, onComplete]);

    return <Animated.View style={[styles.fadeInBlock, { display, opacity, backgroundColor }]}></Animated.View>;
};

const calculateStyles = () => {
    return EStyleSheet.create({
        fadeInBlock: {
            alignSelf: "stretch",
            position: "absolute",
            zIndex: 10000,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            flex: 1,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
        },
    });
};
